/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Toggle from 'react-toggle';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const DemoUsers = props => {

    // variables
    let timeout = 0;

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [demoUsers, setDemoUsers] = useState([]);
    const [modal, setModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [pagination, setPagination] = useState({ limit: 10, page: 1, searchVal: "" });

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true);
            AdminService.getDemoUsers(pagination.limit, pagination.page, pagination.searchVal).then(data => {
                try {
                    setDemoUsers(data.demoUsers);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Admin DemoUsers useEffect', 'Error in try catch block', err.stack);
                    setIsLoading(false);
                }
            });
        }
    }, [pagination.page, pagination.limit, pagination.searchVal]);

    // handle functions
    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin DemoUsers handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            // if(e.target.id === "limit"){
            //     const value = e.target.value;
            //     setTimeout(() => {
            //         setPagination({...pagination, limit: value});
            //     }, 500);
            // }
            // else
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin DemoUsers handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleToggleChange = (index) => {
        try {
            setIsLoading2(true);
            let tempDemoUsers = [...demoUsers];
            tempDemoUsers[index].isActive = !tempDemoUsers[index].isActive;
            setDemoUsers(tempDemoUsers);
            AdminService.updateDemoUsers({ id: tempDemoUsers[index]._id, isActive: tempDemoUsers[index].isActive })
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setConfirmationModal({ isVisible: false, selectedIndex: -1 });
                    setIsLoading2(false);
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading2(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at Admin DemoUsers handleToggleChange', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Demo Users</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        DemoUser List
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="5" className="border-0 px-0">
                                            <div className="d-flex">
                                                <div className="ml-auto">
                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, searchVal: "" }); }}><i className="fa fa-times"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>Login Count</th>
                                        <th align="center" style={{ width: '185px' }}>Is Active</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        demoUsers.map((item, index) => (
                                            <tr key={index}>
                                                <td>{`${item.firstName} ${item.lastName}`}</td>
                                                <td>{item.email}</td>
                                                <td>{item.role}</td>
                                                <td>{item.loginCount}</td>
                                                <td align="center"><Toggle icons={false} checked={item.isActive} onChange={() => setConfirmationModal({ isVisible: true, selectedIndex: index })} /></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="5" className="border-0 pb-0 px-0">
                                            <div className="d-flex">
                                                <ErrorBoundary errorAt="At Admin DemoUsers Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <ErrorBoundary errorAt="At Admin DemoUsers Modal">
                <Modal size="sm" isOpen={confirmationModal.isVisible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setConfirmationModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                    <ModalBody>
                        {
                            confirmationModal.selectedIndex >= 0 ?
                                <Label>By clicking on Save button <b>{demoUsers[confirmationModal.selectedIndex].email}</b> will be <b>{demoUsers[confirmationModal.selectedIndex].isActive ? "Deactivated" : "Activated"}</b> and will be notified via email about this.</Label>
                                : null
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={() => handleToggleChange(confirmationModal.selectedIndex)} disabled={isLoading2}>
                            {isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                        </Button>
                    </ModalFooter>
                </Modal>
            </ErrorBoundary>
        </main>
    )

}

export default DemoUsers;